import styled from 'styled-components'

export const StyledList = styled.ul`
  
    > .list-item {
        margin-bottom: 20px;
        position: relative;
    }
`
